import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HeaderStyle.css";
import logo from "../../assets/logoo.png";
import { Collapse } from "bootstrap";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { t, i18n } = useTranslation();
  const collapseRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute(
      "dir",
      i18n.language === "ar" ? "rtl" : "ltr"
    );
  }, [i18n.language]);

  const toggleLanguage = () => {
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
    document.documentElement.setAttribute(
      "dir",
      newLang === "ar" ? "rtl" : "ltr"
    );
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }

    if (collapseRef.current) {
      const bsCollapse = new Collapse(collapseRef.current, { toggle: false });
      bsCollapse.hide();
    }
  };

  const closeNavbar = () => {
    if (collapseRef.current) {
      const bsCollapse = new Collapse(collapseRef.current, { toggle: false });
      bsCollapse.hide();
    }
  };

  return (
    <nav
      key={i18n.language}
      className={`navbar navbar-expand-lg navbar-dark fixed-top custom-navbar ${
        isScrolled ? "custom-navbar-scrolled" : "custom-navbar-transparent"
      }`}
    >
      <div className="container navbar-container">
        <a
          className="navbar-brand"
          href="#home"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("home");
          }}
        >
          <img src={logo} alt="Logo" className="navbar-logo" />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className="collapse navbar-collapse navbar-collapse-custom"
          id="navbarNav"
          ref={collapseRef}
        >
          <button
            className="navbar-close-btn"
            type="button"
            onClick={closeNavbar}
            aria-label="Close navigation"
          >
            ×
          </button>

          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a
                className="nav-link"
                href="#home"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("home");
                }}
              >
                {t("header.home")}
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("about");
                }}
              >
                {t("header.about")}
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#projects"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("projects");
                }}
              >
                {t("header.projects")}
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#services"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("services");
                }}
              >
                {t("header.services")}
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection("contact");
                }}
              >
                {t("header.contact")}
              </a>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-outline-light language-btn"
                onClick={toggleLanguage}
              >
                {i18n.language === "ar" ? "EN" : "AR"}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
